import React, { useState } from 'react';
import {
  Box,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  TextField,
  IconButton,
  Divider,
  Badge
} from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import { mockUsers } from '../data/mockData';

const Messages: React.FC = () => {
  const [selectedUser, setSelectedUser] = useState<string | null>(null);
  const [message, setMessage] = useState('');

  // Simular conversaciones
  const conversations = mockUsers
    .filter(u => u.role === 'Mentor')
    .map(mentor => ({
      userId: mentor.id,
      name: mentor.name,
      lastMessage: 'Hola, ¿cómo va tu proyecto?',
      unread: Math.random() > 0.5,
      avatar: mentor.avatar
    }));

  const handleSendMessage = () => {
    if (message.trim()) {
      alert(`Mensaje enviado: ${message}`);
      setMessage('');
    }
  };

  return (
    <Box>
      <Typography variant="h4" gutterBottom sx={{ mb: 3 }}>
        Mensajes
      </Typography>

      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '350px 1fr' }, gap: 2, height: 'calc(100vh - 200px)' }}>
        {/* Lista de conversaciones */}
        <Paper sx={{ overflow: 'auto' }}>
          <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
            <Typography variant="h6">Conversaciones</Typography>
          </Box>
          <List sx={{ p: 0 }}>
            {conversations.map((conv, index) => (
              <React.Fragment key={conv.userId}>
                <ListItem
                  onClick={() => setSelectedUser(conv.userId)}
                  sx={{ 
                    cursor: 'pointer',
                    bgcolor: selectedUser === conv.userId ? 'action.selected' : 'transparent',
                    '&:hover': { bgcolor: 'action.hover' }
                  }}
                >
                  <ListItemAvatar>
                    <Badge color="error" variant="dot" invisible={!conv.unread}>
                      <Avatar sx={{ bgcolor: 'primary.main' }}>
                        {conv.avatar}
                      </Avatar>
                    </Badge>
                  </ListItemAvatar>
                  <ListItemText
                    primary={conv.name}
                    secondary={conv.lastMessage}
                    secondaryTypographyProps={{
                      noWrap: true,
                      sx: { fontWeight: conv.unread ? 'bold' : 'normal' }
                    }}
                  />
                </ListItem>
                {index < conversations.length - 1 && <Divider />}
              </React.Fragment>
            ))}
          </List>
        </Paper>

        {/* Ventana de chat */}
        <Paper sx={{ display: 'flex', flexDirection: 'column' }}>
          {selectedUser ? (
            <>
              {/* Header del chat */}
              <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
                <Typography variant="h6">
                  {conversations.find(c => c.userId === selectedUser)?.name}
                </Typography>
              </Box>

              {/* Mensajes */}
              <Box sx={{ flexGrow: 1, p: 2, overflow: 'auto', bgcolor: '#f5f5f5' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                  {/* Mensaje recibido */}
                  <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                    <Paper sx={{ p: 2, maxWidth: '70%', bgcolor: 'white' }}>
                      <Typography variant="body2">
                        Hola, ¿cómo va tu proyecto?
                      </Typography>
                      <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                        10:30 AM
                      </Typography>
                    </Paper>
                  </Box>

                  {/* Mensaje enviado */}
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Paper sx={{ p: 2, maxWidth: '70%', bgcolor: 'primary.main', color: 'white' }}>
                      <Typography variant="body2">
                        ¡Muy bien! Estamos avanzando con la validación del MVP.
                      </Typography>
                      <Typography variant="caption" sx={{ mt: 1, display: 'block', opacity: 0.8 }}>
                        10:35 AM
                      </Typography>
                    </Paper>
                  </Box>
                </Box>
              </Box>

              {/* Input de mensaje */}
              <Box sx={{ p: 2, borderTop: 1, borderColor: 'divider', display: 'flex', gap: 1 }}>
                <TextField
                  fullWidth
                  placeholder="Escribe un mensaje..."
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  onKeyPress={(e) => e.key === 'Enter' && handleSendMessage()}
                  size="small"
                />
                <IconButton color="primary" onClick={handleSendMessage}>
                  <SendIcon />
                </IconButton>
              </Box>
            </>
          ) : (
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
              <Typography variant="body1" color="text.secondary">
                Selecciona una conversación para comenzar
              </Typography>
            </Box>
          )}
        </Paper>
      </Box>
    </Box>
  );
};

export default Messages;
